export default __webpack_public_path__ + "static/media/icon-ETH.11294773.svg";